import { memo } from 'react';

type FlagIconProps = {
  code: string;
  size?: number;
};

// Mapa de código de idioma para código de país (ISO 3166-1 alpha-2)
const countryCodeMap: Record<string, string> = {
  'pt-BR': 'br',
  'en-US': 'us',
  es: 'es',
  'es-ES': 'es',
  fr: 'fr',
  'fr-FR': 'fr',
  de: 'de',
  'de-DE': 'de',
  it: 'it',
  'it-IT': 'it',
  ja: 'jp',
  'ja-JP': 'jp',
  ko: 'kr',
  'ko-KR': 'kr',
  zh: 'cn',
  'zh-CN': 'cn',
  ru: 'ru',
  'ru-RU': 'ru',
  ar: 'sa',
  'ar-SA': 'sa',
  pt: 'pt',
  'pt-PT': 'pt',
  en: 'us',
  'en-GB': 'gb',
};

const resolveCountryCode = (langCode: string): string | null => {
  if (countryCodeMap[langCode]) return countryCodeMap[langCode];

  const base = langCode.split('-')[0].toLowerCase();
  if (countryCodeMap[base]) return countryCodeMap[base];

  return null;
};

const FlagIcon = ({ code, size = 20 }: FlagIconProps) => {
  const countryCode = resolveCountryCode(code);

  if (!countryCode) {
    return <span style={{ fontSize: size * 0.8 }}>🌐</span>;
  }

  return (
    <img
      src={`https://flagcdn.com/w40/${countryCode}.png`}
      srcSet={`https://flagcdn.com/w80/${countryCode}.png 2x`}
      alt={code}
      style={{
        width: size,
        height: size * 0.75,
        objectFit: 'cover',
        borderRadius: 3,
        flexShrink: 0,
      }}
    />
  );
};

export default memo(FlagIcon);
